import React from 'react'
import styled from 'styled-components'
import { CircleButton, Flex, mq } from '@revolut/ui-kit'
import { NavigationBack } from '@revolut/icons'
import { Props } from '../CardSlide'

const FixedCircleButton = styled(CircleButton)`
  position: fixed;
  @media ${mq('all')} {
    left: 2rem;
    top: 2rem;
  }
`

const StickyFlex = styled(Flex).attrs({
  width: '100vw',
  height: '4rem',
  bg: 'white',
  alignItems: 'center',
  px: '1rem',
})`
  position: sticky;
  top: 0;
  z-index: 1;
`

type BackButtonType = { onBack: Props['onBack'] }

export const BackButton: React.FC<BackButtonType> = ({ onBack }) =>
  !onBack ? null : (
    <>
      <FixedCircleButton
        hide='*-md'
        variant='outline'
        elevation={0}
        scaleOnHover={false}
        onClick={onBack}
        size='md'
      >
        <NavigationBack size='24' color='grey-50' />
      </FixedCircleButton>
      <StickyFlex hide='md-*'>
        <NavigationBack size='24' color='grey-50' onClick={onBack} />
      </StickyFlex>
    </>
  )
